import { useEffect, useRef, useState } from 'react';

interface Options {
  /** 0..1. Default 0.3 = el elemento entra cuando 30% es visible. */
  threshold?: number;
  /** Si true, una vez visible queda en true para siempre. Default true. */
  once?: boolean;
  /** Offset al rootMargin. Ej: '-80px' para activar más tarde. */
  rootMargin?: string;
}

export function useInView<T extends HTMLElement>(opts: Options = {}) {
  const { threshold = 0.3, once = true, rootMargin = '0px' } = opts;
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (once) observer.unobserve(el);
        } else if (!once) {
          setInView(false);
        }
      },
      { threshold, rootMargin },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, once, rootMargin]);

  return { ref, inView };
}
